import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

export default function Shop() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        api.get("/products").then((r) => setProducts(r.data || []));
    }, []);

    return (
        <div data-testid="shop-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
            <div className="grid md:grid-cols-12 gap-10 mb-20 items-end">
                <div className="md:col-span-8">
                    <div className="eyebrow text-[#B8860B] mb-6">The Shop</div>
                    <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]">
                        Goods made <em className="italic">slowly</em>, like the show.
                    </h1>
                </div>
                <div className="md:col-span-4">
                    <p className="text-black/65 font-light leading-relaxed">
                        Studio merch made in small batches with fair-trade partners. 10% of profits go to listener-nominated nonprofits.
                    </p>
                </div>
            </div>
            {products.length === 0 ? (
                <div data-testid="shop-empty" className="border border-black/10 py-20 text-center bg-white">
                    <div className="font-serif text-3xl mb-4">The shelves are being restocked.</div>
                    <p className="text-black/60 font-light max-w-md mx-auto">
                        New goods will appear here soon. In the meantime, give an episode a listen.
                    </p>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {products.map((p) => <ProductCard key={p.id} product={p} />)}
                </div>
            )}
        </div>
    );
}
